import { createContext } from 'react'

export const ArtistContext = createContext({})
